<template>
  <div class="prev-or-next">
    <button :class="[{ preDisabled: preDisabled }, 'btn-pre']" :disabled="preDisabled" @click="changeQues('prev')">上一题
    </button>
    <button :class="[{ nextDisabled: nextDisabled }, 'btn-next']" :disabled="nextDisabled" @click="changeQues('next')">
      下一题
    </button>
    <slot name="list"/>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'prevOrNext',
    computed: {
      ...mapGetters([
        'questions',
        'currentQuestionType',
        'currentQuestionIndex',
        'currentQuestion'
      ]),
      preDisabled() {
        return (parseInt(this.currentQuestionType) === 0 && parseInt(this.currentQuestionIndex) === 0)
      },
      nextDisabled() {
        let lastQuesType = this.questions.length - 1
        return (parseInt(this.currentQuestionType) === lastQuesType && parseInt(this.currentQuestionIndex) === this.questions[lastQuesType].list.length - 1)
      }
    },
    methods: {
      changeQues(type) {
        let newQuesType = this.currentQuestionType, newQuesIndex = this.currentQuestionIndex
        switch (type) {
          case 'prev':
            if (parseInt(this.currentQuestionIndex) === 0) {
              newQuesType--
              newQuesIndex = this.questions[newQuesType].list.length - 1
            } else {
              newQuesIndex--
            }
            break
          case 'next':
            //如果当前小题的序号 = 该大题中最后一个小题序号，则转到下一个大题中
            if (parseInt(this.currentQuestionIndex) === this.questions[this.currentQuestionType].list.length - 1) {
              newQuesIndex = 0
              newQuesType++
            } else {
              newQuesIndex++
            }
            break
        }
        this.$emit('buttonFn', newQuesType, newQuesIndex, this.currentQuestion)
      }
    }
  }
</script>
<style lang="scss" scoped>
  $imgUrl: '~@/assets/images/doExam/';
  .prev-or-next {
    button {
      display: inline-block;
      width: 87px;
      height: 25px;
      border: 0;
      font-size: 0;
      margin-right: 5px;
    }

    .btn-pre {
      background: url($imgUrl + 'preAble.jpg');
    }

    .preDisabled {
      background: url($imgUrl + 'preDisable.jpg');
    }

    .btn-next {
      background: url($imgUrl + 'nextAble.jpg');
    }

    .nextDisabled {
      background: url($imgUrl + 'nextDisable.jpg');
    }
  }
</style>
